// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"f97100e3","493":"f1a3ff22","589":"61673b27","655":"0a596c05","812":"d02ff0f3"}[chunkId] + ".chunk.js";
};